<template>
  <primary-confirm-dialog
    v-if="show"
    :value="true"
    :confirm-text="confirmText"
    :cancel-text="cancelText"
    :confirm-btn-color="confirmBtnColor"
    :max-width="extraText ? '608px' : '560px'"
    @confirm="confirm"
    @cancel="cancel"
  >
    <template #title>
      {{ title }}
    </template>
    <template #subtitle>
      <div v-if="content" class="font-weight-medium text--accent-3 text-center">
        {{ content }}
      </div>
    </template>
    <template v-if="extraText" #extra-btn>
      <large-btn
        class="primary-confirm-dialog_btn primary-confirm-dialog_btn__extra"
        :color="extraBtnColor"
        height="64px"
        :uppercase="false"
        block
        @click="extra"
      >
        <v-icon
          v-if="extraIcon"
          size="20"
          color="#fff"
          class="mr-2"
        >
          {{ extraIcon }}
        </v-icon>
        {{ extraText }}
      </large-btn>
    </template>
  </primary-confirm-dialog>
</template>
<script>
  import PrimaryConfirmDialog from '@/components/ui/dialogs/PrimaryConfirmDialog.vue'
  import LargeBtn from '@/components/ui/buttons/LargeBtn.vue'
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'GlobalConfirmDialog',
    components: { PrimaryConfirmDialog, LargeBtn },
    computed: {
      ...mapState({
        show: state => state.confirmDialog.show,
        title: state => state.confirmDialog.title,
        content: state => state.confirmDialog.content,
        confirmText: state => state.confirmDialog.confirmText,
        cancelText: state => state.confirmDialog.cancelText,
        confirmBtnColor: state => state.confirmDialog.confirmBtnColor,
        extraText: state => state.confirmDialog.extraText,
        extraBtnColor: state => state.confirmDialog.extraBtnColor,
        extraIcon: state => state.confirmDialog.extraIcon,
      }),
    },
    methods: {
      ...mapActions({
        confirm: 'confirmDialog/confirm',
        cancel: 'confirmDialog/cancel',
        extra: 'confirmDialog/extra',
      }),
    },
  }
</script>

<style scoped lang="less">

</style>
